import React, { ReactElement } from "react";
import Modal from "../shared/components/modal/Modal";

export type ValidatiePopupProps = {
  infotekst: string;
  show: boolean;
  onHide: () => void;
  onSubmit?: () => void;
  navigatiepopup?: boolean;
};
export const ValidatiePopup = ({ ...props }: ValidatiePopupProps): ReactElement => {
  return (
    <Modal
      title="Er zijn niet opgeslagen gegevens op deze pagina"
      body={
        <p>
          Er zijn niet opgeslagen gegevens op deze pagina. Als je toch van voorstel wisselt dan wordt alle door jou
          gewijzigde data niet opgeslagen.
        </p>
      }
      submitButtonVariant="danger"
      saveButtonTekst="Verwijder mijn aanpassingen en navigeer"
      noEditableData={!props.navigatiepopup}
      onSubmitClick={props.onSubmit}
      onCancelClick={props.onHide}
      isFormDirty={true}
    />
  );
};
